<mat-toolbar>
    <mat-icon [routerLink]="['/home']" svgIcon='logo' aria-hidden="false" aria-label="logo icon which navigates to welcome view">
    </mat-icon>
    <mat-nav-list>
        <a mat-list-item [routerLink]="['/home']">home</a>
        <a mat-list-item [routerLink]="['/photoshop-search-ids', 'char']">char ids</a>
        <a mat-list-item [routerLink]="['/photoshop-search-ids', 'string']">string ids</a>
    </mat-nav-list>
</mat-toolbar>